import { render, staticRenderFns } from "./NormalSearchNav124.vue?vue&type=template&id=56ca3cd2&scoped=true"
import script from "./NormalSearchNav124.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav124.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ca3cd2",
  null
  
)

export default component.exports